import React from "react";
import "./styles/ReportDB.css";

const ReportDB = () => {
  return (
    <div>
      <h1>Report DB (Reporter)</h1>
      <p>Here you can create, edit, delete your report‑type articles.</p>
      {/* Later: fetch your report articles, show CRUD UI */}
    </div>
  );
};

export default ReportDB;
